import { render, staticRenderFns } from "./PageForms.vue?vue&type=template&id=515d6cb0&scoped=true&"
import script from "./PageForms.vue?vue&type=script&lang=js&"
export * from "./PageForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d6cb0",
  null
  
)

export default component.exports